module.exports = __webpack_public_path__ + "img/customer.0a96c865.png";